import script from "./CountDown.vue?vue&type=script&lang=ts&setup=true"
export * from "./CountDown.vue?vue&type=script&lang=ts&setup=true"

import "./CountDown.vue?vue&type=style&index=0&id=d64be0e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d64be0e6"]])

export default __exports__